import React from 'react'

function Profil() {
  return (
    
    <div className="flex-1 grid grid-cols-8 bg-gray-100 md:mt-16 p-6"> 
      
      <div className="col-span-2 bg-white mr-8 p-6 border rounded">
  
      <a href="#" className="uppercase tracking-wider btn-bs-dark">
          <i className="mr-2 fa-layer-plus fad"></i>
          Compose
      </a>
      <hr className="my-6"/>
  
      <ul>
          <li className="my-5 mt-0">
              <a className="text-left btn-indigo" href="#">
                  <i className="mr-1 text-xs fa-inbox fad"></i>
                  inbox
              </a>
          </li>
          
  
          <li>
              <a className="bg-white hover:bg-gray-100 text-gray-800 text-left hover:text-gray-900 btn" href="#">
                  <i className="mr-1 text-xs fa-paper-plane fad"></i>
                  sent
              </a>
          </li>
  
  
          <li>
              <a className="bg-white hover:bg-gray-100 text-gray-800 text-left hover:text-gray-900 btn" href="#">
                  <i className="mr-1 text-xs fa-star fad"></i>
                  Marked
              </a>
          </li>
          
  
          <li>
              <a className="bg-white hover:bg-gray-100 text-gray-800 text-left hover:text-gray-900 btn" href="#">
                  <i className="mr-1 text-xs fa-inbox-in fad"></i>
                  draft
              </a>
          </li>
          
  
          <li>
              <a className="bg-white hover:bg-gray-100 text-gray-800 text-left hover:text-gray-900 btn" href="#">
                  <i className="mr-1 text-xs fa-inbox-out fad"></i>
                  sent
              </a>
          </li>
          
  
          <li>
              <a className="bg-white hover:bg-gray-100 text-gray-800 text-left hover:text-gray-900 btn" href="#">
                  <i className="mr-1 text-xs fa-trash fad"></i>
                  trash
              </a>
          </li>
  
          {/* seprator */}
          <hr className="my-10"/>
  
          <li>
              <a className="bg-white hover:bg-gray-100 text-gray-800 text-left hover:text-gray-900 btn" href="#">
                  <i className="mr-1 text-indigo-700 fa-dot-circle fad"></i>
                  Custom Work
              </a>
          </li>
  
  
          <li>
              <a className="bg-white hover:bg-gray-100 text-gray-800 text-left hover:text-gray-900 btn" href="#">
                  <i className="mr-1 text-gray-700 fa-dot-circle fad"></i>
                  Important 
              </a>
          </li>
  
  
          <li>
              <a className="bg-white hover:bg-gray-100 text-gray-800 text-left hover:text-gray-900 btn" href="#">
                  <i className="mr-1 text-green-700 fa-dot-circle fad"></i>
                  work
              </a>
          </li>
  
  
          <li>
              <a className="bg-white hover:bg-gray-100 text-gray-800 text-left hover:text-gray-900 btn" href="#">
                  <i className="mr-1 text-yellow-700 fa-dot-circle fad"></i>
                  design
              </a>
          </li>
  
  
          <li>
              <a className="bg-white hover:bg-gray-100 text-gray-800 text-left hover:text-gray-900 btn" href="#">
                  <i className="mr-1 text-red-700 fa-dot-circle fad"></i>
                  laravel
              </a>
          </li>
  
          <li>
              <a className="bg-white hover:bg-gray-100 text-gray-800 text-left hover:text-gray-900 btn" href="#">
                  <i className="mr-1 text-teal-800 fa-dot-circle fad"></i>
                  add new label
              </a>
          </li>       
          
      </ul>
  
  </div>
      <div className="flex flex-col col-span-6 card">
  
      <div className="px-3 border-b">
          <form action="" className="flex">
              <input className="flex-1 p-3" type="text" placeholder="search"/>
              <button type="submit" className="p-3">
                  <i className="fa-search fad"></i>
              </button>
          </form>
      </div>
  
      <div className="flex flex-col flex-1">
  
          {/* message */}
          <div className="flex items-center shadow-xs hover:shadow-md p-5 transition-all duration-300 ease-in-out">
              <div className="rounded-md w-10 h-10 overflow-hidden">
                  <img className="img-responsive" src="assets/img/user1.jpg" alt=""/>
              </div>    
              <h1 className="ml-3">mohamed</h1>    
              <p className="flex-1 ml-6 text-xs">page when looking at its layout looking at its layout The point of using Lorem...</p>    
              <p className="font-bold text-gray-900">05:09 AM</p>
          </div>
          {/* message */}
          {/* message */}
          <div className="flex items-center shadow-xs hover:shadow-md p-5 transition-all duration-300 ease-in-out">
              <div className="rounded-md w-10 h-10 overflow-hidden">
                  <img className="img-responsive" src="assets/img/user1.jpg" alt=""/>
              </div>    
              <h1 className="ml-3">mohamed</h1>    
              <p className="flex-1 ml-6 text-xs">page when looking at its layout looking at its layout The point of using Lorem...</p>    
              <p className="font-bold text-gray-900">05:09 AM</p>
          </div>
          {/* message */}
          {/* message */}
          <div className="flex items-center shadow-xs hover:shadow-md p-5 transition-all duration-300 ease-in-out">
              <div className="rounded-md w-10 h-10 overflow-hidden">
                  <img className="img-responsive" src="assets/img/user1.jpg" alt=""/>
              </div>    
              <h1 className="ml-3">mohamed</h1>    
              <p className="flex-1 ml-6 text-xs">page when looking at its layout looking at its layout The point of using Lorem...</p>    
              <p className="font-bold text-gray-900">05:09 AM</p>
          </div>
          {/* message */}
          {/* message */}
          <div className="flex items-center shadow-xs hover:shadow-md p-5 transition-all duration-300 ease-in-out">
              <div className="rounded-md w-10 h-10 overflow-hidden">
                  <img className="img-responsive" src="assets/img/user1.jpg" alt=""/>
              </div>    
              <h1 className="ml-3">mohamed</h1>    
              <p className="flex-1 ml-6 text-xs">page when looking at its layout looking at its layout The point of using Lorem...</p>    
              <p className="font-bold text-gray-900">05:09 AM</p>
          </div>
          {/* message */}
          {/* message */}
          <div className="flex items-center shadow-xs hover:shadow-md p-5 transition-all duration-300 ease-in-out">
              <div className="rounded-md w-10 h-10 overflow-hidden">
                  <img className="img-responsive" src="assets/img/user1.jpg" alt=""/>
              </div>    
              <h1 className="ml-3">mohamed</h1>    
              <p className="flex-1 ml-6 text-xs">page when looking at its layout looking at its layout The point of using Lorem...</p>    
              <p className="font-bold text-gray-900">05:09 AM</p>
          </div>
          {/* message */}
          {/* message */}
          <div className="flex items-center shadow-xs hover:shadow-md p-5 transition-all duration-300 ease-in-out">
              <div className="rounded-md w-10 h-10 overflow-hidden">
                  <img className="img-responsive" src="assets/img/user1.jpg" alt=""/>
              </div>    
              <h1 className="ml-3">mohamed</h1>    
              <p className="flex-1 ml-6 text-xs">page when looking at its layout looking at its layout The point of using Lorem...</p>    
              <p className="font-bold text-gray-900">05:09 AM</p>
          </div>
          {/* message */}
          {/* message */}
          <div className="flex items-center shadow-xs hover:shadow-md p-5 transition-all duration-300 ease-in-out">
              <div className="rounded-md w-10 h-10 overflow-hidden">
                  <img className="img-responsive" src="assets/img/user1.jpg" alt=""/>
              </div>    
              <h1 className="ml-3">mohamed</h1>    
              <p className="flex-1 ml-6 text-xs">page when looking at its layout looking at its layout The point of using Lorem...</p>    
              <p className="font-bold text-gray-900">05:09 AM</p>
          </div>
          {/* message */}
          {/* message */}
          <div className="flex items-center shadow-xs hover:shadow-md p-5 transition-all duration-300 ease-in-out">
              <div className="rounded-md w-10 h-10 overflow-hidden">
                  <img className="img-responsive" src="assets/img/user1.jpg" alt=""/>
              </div>    
              <h1 className="ml-3">mohamed</h1>    
              <p className="flex-1 ml-6 text-xs">page when looking at its layout looking at its layout The point of using Lorem...</p>    
              <p className="font-bold text-gray-900">05:09 AM</p>
          </div>
          {/* message */}
          {/* message */}
          <div className="flex items-center shadow-xs hover:shadow-md p-5 transition-all duration-300 ease-in-out">
              <div className="rounded-md w-10 h-10 overflow-hidden">
                  <img className="img-responsive" src="assets/img/user1.jpg" alt=""/>
              </div>    
              <h1 className="ml-3">mohamed</h1>    
              <p className="flex-1 ml-6 text-xs">page when looking at its layout looking at its layout The point of using Lorem...</p>    
              <p className="font-bold text-gray-900">05:09 AM</p>
          </div>
          {/* message */}
  
      </div>
  
      <div className="flex justify-between card-footer">
          <p>4.41 GB (25%) of 17 GB used Manage</p>
          <p>Last account activity: 36 minutes ago</p>
      </div>
  </div>
  
    </div>
    
  )
}

export default Profil